import React from 'react';
import clsx from 'clsx';
import { FileFormatIcon, Flex, Skeleton, Text } from '@/components/ui';

interface FileNameCellProps {
  value?: unknown;
  filename?: string;
  mimeType?: string;
  showIcon?: boolean;
  truncate?: boolean;
  endSlot?: React.ReactNode;
  className?: string;
  render?: () => React.ReactNode;
}

function FileNameCell({
  value,
  filename,
  mimeType,
  showIcon = true,
  truncate = true,
  endSlot,
  className,
  render,
}: FileNameCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  // Extract filename from value if filename prop is not provided
  const displayFilename = filename || (value as string) || '';

  if (!displayFilename) {
    return (
      <Text size="2" color="gray">
        —
      </Text>
    );
  }

  return (
    <Flex
      gap="2"
      align="center"
      className={clsx('data-cell__file-name', className)}
    >
      {showIcon && (
        <FileFormatIcon
          fileName={displayFilename}
          mimeType={mimeType}
          size="small"
        />
      )}
      <Text
        size="xsmall"
        weight="medium"
        truncate={truncate}
        title={truncate ? displayFilename : undefined}
      >
        {displayFilename}
      </Text>
      {endSlot && <>{endSlot}</>}
    </Flex>
  );
}

export function FileNameCellSkeleton() {
  return (
    <Flex gap="2" align="center">
      <Skeleton
        style={{ width: '32px', height: '32px', borderRadius: '4px' }}
      />
      <Skeleton
        style={{ width: '180px', height: '16px', borderRadius: '4px' }}
      />
    </Flex>
  );
}

export default FileNameCell;
